import React from "react";
import { IoIosMenu } from "react-icons/io";

function UpDownArrow({ dragHandleProps, className }: any) {
    return (
        <div
            {...dragHandleProps}
            className={className}
            aria-label="move"
            role="img"
        >
            <IoIosMenu
                style={{
                    fill: "#848484",
                    width: "50px",
                    height: "50px",
                }}
                className="epb_icn_dragAndDropIconeAS"
            />
        </div>
    );
}

export default UpDownArrow;
